import React from 'react';
import { Grid, Typography } from '@mui/material';
import CalendarMonth from './CalendarMonth';

/**
 * Calendar grid component that organizes months by year
 *
 * @param {Object} props
 * @param {Object} props.monthsByYear - Object with years as keys and arrays of months as values
 * @param {Map} props.itemsByDate - Map of items by date string
 * @param {Array} props.batchRanges - Array of batch send date ranges for highlighting
 * @param {Function} props.onDayClick - Handler for clicking on a day
 * @param {boolean} props.isMoveMode - Whether in move mode
 * @param {Object} props.contentTypeColors - Map of content types to colors
 * @returns {JSX.Element}
 */

const CalendarGrid = ({ monthsByYear, itemsByDate, batchRanges, onDayClick, isMoveMode, contentTypeColors }) => {
    return (
        <>
            {Object.entries(monthsByYear).map(([year, months]) => (
                <React.Fragment key={year}>
                    <Grid item xs={12}>
                        <Typography variant="h2" gutterBottom sx={{ mt: 2 }}>
                            {year}
                        </Typography>
                    </Grid>
                    <Grid container spacing={2} sx={{ mb: 4 }}>
                        {months.map(monthIndex => (
                            <Grid item xs={12} sm={12} md={6} lg={4} key={`${year}-${monthIndex}`}>
                                <CalendarMonth
                                    year={parseInt(year)}
                                    month={monthIndex}
                                    itemsByDate={itemsByDate}
                                    batchRanges={batchRanges}
                                    onDayClick={onDayClick}
                                    isMoveMode={isMoveMode}
                                    contentTypeColors={contentTypeColors}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </React.Fragment>
            ))}
        </>
    );
};

export default React.memo(CalendarGrid);